// Module
var code = "<kov-simple-header></kov-simple-header> <div class=\"confirmation-container\"> <div class=\"confirm-icon-circle\"> <span ng-show=\"ctrl.sIcon\" ng-include=\"ctrl.sIcon\"></span> </div> <div class=\"confirmation-title\">{{ctrl.sTitle}}</div> <div ng-transclude></div> </div>";
// Exports
module.exports = code;